import { render, staticRenderFns } from "./carousel.component.vue?vue&type=template&id=1ead1fa6&scoped=true"
import script from "./carousel.component.vue?vue&type=script&lang=ts"
export * from "./carousel.component.vue?vue&type=script&lang=ts"
import style0 from "./carousel.component.vue?vue&type=style&index=0&id=1ead1fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ead1fa6",
  null
  
)

export default component.exports